import React from 'react';
import _ from 'lodash';
import { useMatchDetails } from '../hooks/matchdetails';
import MatchDetailsUpcoming from './MatchDetailsUpcoming';
import MatchDetailsOngoingFinished from './MatchDetailsOngoingFinished';
import { useTeamLogo } from '../hooks/team';
import Loader from '../components/Loader';

function MatchDetails() {
  const { id, season } = window.pageData.data;
  const [match, loading] = useMatchDetails(id, season);
  const [homeTeamLogo] = useTeamLogo(match?.homeTeamAbbrv);
  const [visitingTeamLogo] = useTeamLogo(match?.visitingTeamAbbrv);

  if (loading) return <Loader />;

  if (['ONGOING', 'FINISHED'].includes(match?.status)) {
    return (
      <MatchDetailsOngoingFinished
        match={match}
        homeTeamLogo={homeTeamLogo}
        visitingTeamLogo={visitingTeamLogo}
      />
    );
  }

  return (
    <MatchDetailsUpcoming
      match={match}
      homeTeamLogo={homeTeamLogo}
      visitingTeamLogo={visitingTeamLogo}
    />
  );
}

export default MatchDetails;
